import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Variant } from 'app/models/variant.models';
import { AuthService } from 'app/services/auth.service';
import { ProductoService } from 'app/services/producto.service';

@Component({
  selector: 'app-variantes-articulo',
  templateUrl: './variantes-articulo.component.html',
  styleUrls: ['./variantes-articulo.component.css'],
})
export class VariantesArticuloComponent {
  form: UntypedFormGroup;
  typeVariantes = [];
  selectedtype: any;
  idArticulo: number;
  measurementUnitId: number;
  propiedades = [];
  varianteIngresada: Variant;
  modoEdicion: boolean = false;

  constructor(
    private articuloService: ProductoService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    public dialogRef: MatDialogRef<VariantesArticuloComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.modoEdicion = this.data.modoEdicion;
    this.idArticulo = this.data.idArticulo;
    this.varianteIngresada = this.data.variante;
    this.measurementUnitId = this.data.measurementUnitId;
    this.form = this.fb.group({
      type: [0, Validators.required],
      typeItem: '',
      peso: 0,
      alto: 0,
      ancho: 0,
      barCode: '',
      largo: 0,
      stock: 1,
      min: 1,
      max: 1,
      sku: '',
      precio: [0, Validators.required],
    });
    this.gettypeVariante();

    this.form.controls.type.valueChanges.subscribe(da => {
      const itemSelect = this.typeVariantes.find(x => x.id == da);
      this.selectedtype = itemSelect;
      if (itemSelect) {
        this.propiedades = JSON.parse(itemSelect.value);
        // está editando una variante
        if (this.varianteIngresada) {
          console.log(this.varianteIngresada);
          this.propiedades.forEach(propiedad => {
            if (this.varianteIngresada.name == propiedad.name) {
              // seteamos la propiedad type
              this.form.controls.typeItem.patchValue(propiedad.name);
            }
          });
        }
      }
    });
  }

  gettypeVariante() {
    this.articuloService.gettypeVariantes().subscribe(
      typeVariantes => {
        this.typeVariantes = typeVariantes;
        if (this.typeVariantes.length > 0) {
          this.form.controls.type.patchValue(this.typeVariantes[0]);
        }
        // preguntamos si se esta editando una variante
        if (this.varianteIngresada) {
          this.form.controls.type.patchValue(this.varianteIngresada.variantTypeId);
          this.form.controls.typeItem.patchValue(this.varianteIngresada.name);
          this.form.controls.peso.patchValue(this.varianteIngresada?.weight);
          this.form.controls.alto.patchValue(this.varianteIngresada?.height);
          this.form.controls.ancho.patchValue(this.varianteIngresada?.width);
          this.form.controls.largo.patchValue(this.varianteIngresada?.length);
          this.form.controls.precio.patchValue(this.varianteIngresada?.price);
          this.form.controls.barCode.patchValue(this.varianteIngresada?.barCode);
          this.form.controls.min.patchValue(this.varianteIngresada?.stocks[0]?.stockMin);
          this.form.controls.max.patchValue(this.varianteIngresada?.stocks[0]?.stockMax);
          this.form.controls.stock.patchValue(
            this.varianteIngresada?.stocks[0]?.quantity
          );
          this.form.controls.sku.patchValue(this.varianteIngresada?.sku);
          
          // Deshabilitar el campo de stock cuando se edita una variante existente
          this.form.controls.stock.disable();
        }
      },
      err => {
        this.snackBar.open('Error al obtener los tipos de variantes', 'Cerrar', {
          duration: 6000,
        });
      }
    );
  }

  salir() {
    this.dialogRef.close();
  }

  guardarVariante() {
    const user = this.authService.getUID();
    if (!this.varianteIngresada) {
      // buscamos el type
      let variante = new Variant();
      variante.name = this.form.controls.typeItem.value;
      variante.variantTypeId = this.form.controls.type.value;
      variante.weight = this.form.controls.peso.value;
      variante.height = this.form.controls.alto.value;
      variante.width = this.form.controls.ancho.value;
      variante.length = this.form.controls.largo.value;
      variante['quantity'] = this.form.controls.stock.value;
      variante.price = this.form.controls.precio.value;
      variante.sku = this.form.controls.sku.value;
      variante['stockMin'] = this.form.controls.min.value;
      variante['stockMax'] = this.form.controls.max.value;
      variante.barCode = this.form.controls.barCode.value;
      variante.warehouseId = 1;
      variante.measurementUnitId = this.measurementUnitId;
      variante.articleId = this.idArticulo;
      variante.user = user;
      //variante.images = [];
      this.articuloService.guardarVariante(variante).subscribe(
        res => {
          this.snackBar.open('Variante creada correctamente', 'Cerrar', {
            duration: 6000,
          });
          this.dialogRef.close(true);
        },
        err => {
          console.log(err);
          this.snackBar.open('Error al guardar la variante', 'Cerrar', {
            duration: 6000,
          });
        }
      );
    } else {
      // actualizamos la variante
      const idVariante = this.varianteIngresada.id;
      this.varianteIngresada.id = idVariante;
      this.varianteIngresada.name = this.form.controls.typeItem.value;
      this.varianteIngresada.variantTypeId = this.form.controls.type.value;
      this.varianteIngresada.weight = this.form.controls.peso.value;
      this.varianteIngresada.height = this.form.controls.alto.value;
      this.varianteIngresada.width = this.form.controls.ancho.value;
      this.varianteIngresada.length = this.form.controls.largo.value;
      // Mantener el stock actual cuando se edita una variante existente
      // No debemos tomar el valor del formulario ya que está deshabilitado
      // Si los stocks existen, conservamos el quantity existente
      if (this.varianteIngresada.stocks && this.varianteIngresada.stocks[0]) {
        this.varianteIngresada.stock = this.varianteIngresada.stocks[0].quantity;
      }
      this.varianteIngresada.price = this.form.controls.precio.value;
      this.varianteIngresada.sku = this.form.controls.sku.value;
      this.varianteIngresada.min = this.form.controls.min.value;
      this.varianteIngresada.max = this.form.controls.max.value;
      this.varianteIngresada.barCode = this.form.controls.barCode.value;
      this.varianteIngresada.warehouseId = 1;
      this.varianteIngresada.measurementUnitId = this.measurementUnitId;
      this.varianteIngresada.user = user;

      this.articuloService.modificarVariante(this.varianteIngresada).subscribe(
        res => {
          this.snackBar.open('Variante modificada', 'Cerrar', {
            duration: 6000,
          });
          this.dialogRef.close(true);
        },
        err => {
          console.log(err);
          this.snackBar.open('Error al modificar la variante', 'Cerrar', {
            duration: 6000,
          });
        }
      );
    }
  }

  // obtenemos un nuevo code de barras aleatorio
  nuevocodeBarras() {
    this.articuloService.getNuevocodeBarrasArticulos().subscribe(
      data => {
        this.form.controls.barCode.setValue(data.barCode, {
          onlySelf: true,
        });
      },
      err =>
        this.snackBar.open(`Ocurrió un error al obtener código de barras`, 'Cerrar', {
          duration: 6000,
        })
    );
  }
}
